import * as React from 'react';

import { StatsigProvider } from '@coursera-web/statsig';

import LoggedInAdminDesktopMainNav from 'bundles/composable-page-header-admin/main-nav-modules/desktop/LoggedInAdminDesktopMainNav';
import LoggedInAdminMobileMainNav from 'bundles/composable-page-header-admin/main-nav-modules/mobile/LoggedInAdminMobileMainNav';
import AdminPageHeaderProvider from 'bundles/composable-page-header-admin/providers/AdminPageHeaderProvider';
import GlobalPageHeaderContainer from 'bundles/composable-page-header/components/GlobalPageHeaderContainer';
import GlobalPageHeaderStateProvider from 'bundles/composable-page-header/providers/GlobalPageHeaderStateProvider';

const AdminPageHeader = () => {
  return (
    <GlobalPageHeaderContainer
      desktopMainNav={<LoggedInAdminDesktopMainNav />}
      mobileMainNav={<LoggedInAdminMobileMainNav />}
    />
  );
};

const AdminPageHeaderWithProvider = () => {
  return (
    <StatsigProvider>
      <GlobalPageHeaderStateProvider additionalDefaultPageHeaderHeight={undefined}>
        <AdminPageHeaderProvider>
          <AdminPageHeader />
        </AdminPageHeaderProvider>
      </GlobalPageHeaderStateProvider>
    </StatsigProvider>
  );
};

export default AdminPageHeaderWithProvider;
